import React, { useEffect, useState } from "react";
import Navbar from "../components/helpers/Navbar";
import AddMemberModal from "../components/membri/AddMemberModal";
import MemberTable from "../components/membri/MemberTable";
import ExportButtons from "../components/membri/ExportButtons";
import Footer from "../components/helpers/Footer";

const API_BASE = "https://prdp-api.suport-949.workers.dev/api/membri";

// Token hardcodat pentru autentificare
const TOKEN = "unwantedtok";
const AUTH_HEADER = {
  Authorization: `Bearer ${TOKEN}`,
};

const Membri = () => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null); // pentru editare

  // Fetch membrii la montare
  useEffect(() => {
    const fetchMembers = async () => {
      try {
        setLoading(true);
        const res = await fetch(API_BASE, {
          headers: AUTH_HEADER,
        });
        const data = await res.json();
        setMembers(data);
      } catch (err) {
        console.error("Eroare la preluarea membrilor:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchMembers();
  }, []);

  const addMember = async (newMember) => {
    try {
      if (selectedMember) {
        // Editare membru
        const response = await fetch(`${API_BASE}/${selectedMember.id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            ...AUTH_HEADER,
          },
          body: JSON.stringify(newMember),
        });
        if (!response.ok) throw new Error("Eroare la editare membru");

        setMembers((prev) =>
          prev.map((m) => (m.id === selectedMember.id ? newMember : m))
        );
      } else {
        // Adăugare membru nou
        const response = await fetch(API_BASE, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...AUTH_HEADER,
          },
          body: JSON.stringify(newMember),
        });
        if (!response.ok) throw new Error("Eroare la adăugare membru");

        const createdMember = await response.json();
        setMembers((prev) => [...prev, createdMember]);
      }

      setShowModal(false);
      setSelectedMember(null);
    } catch (err) {
      console.error("Eroare la salvare:", err);
    }
  };

  const deleteMember = async (id) => {
    try {
      const response = await fetch(`${API_BASE}/${id}`, {
        method: "DELETE",
        headers: AUTH_HEADER,
      });
      if (!response.ok) throw new Error("Eroare la ștergere membru");

      setMembers((prev) => prev.filter((m) => m.id !== id));
    } catch (err) {
      console.error("Eroare la ștergere:", err);
    }
  };

  const handleEdit = (member) => {
    setSelectedMember(member);
    setShowModal(true);
  };

  const handleHideModal = () => {
    setShowModal(false);
    setSelectedMember(null);
  };

  return (
    <div>
      <Navbar />
      <div className="container py-5">
        <h2 className="mb-4 text-center text-primary-dark">Listă Membri</h2>

        <button
          className="btn btn-primary btn-primary-admin mb-3"
          onClick={() => setShowModal(true)}
        >
          Adaugă membru
        </button>

        {loading ? (
          <div className="text-center">Se încarcă...</div>
        ) : (
          <>
            <MemberTable
              members={members}
              onDelete={deleteMember}
              onEdit={handleEdit}
            />
            <ExportButtons data={members} />
          </>
        )}

        <AddMemberModal
          show={showModal}
          onHide={handleHideModal}
          onSave={addMember}
          initialData={selectedMember}
        />

        <Footer />
      </div>
    </div>
  );
};

export default Membri;
